import React, { useEffect, useState } from 'react';
import { Filter, Star } from 'lucide-react';
import { Button } from '../ui/button';
import { Slider } from '../ui/slider';
import { Input } from '../ui/input';
import { Popover, PopoverContent, PopoverTrigger } from '../ui/popover';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';

const BarbershopMapFiltersComponent = ({
  open,
  onOpenChange,
  cityOptions,
  comunaOptions,
  selectedCity,
  setSelectedCity,
  selectedComuna,
  setSelectedComuna,
  minRating,
  setMinRating,
  maxPrice,
  setMaxPrice
}) => {
  const [priceDraft, setPriceDraft] = useState(String(maxPrice || 0));

  useEffect(() => {
    setPriceDraft(String(maxPrice || 0));
  }, [maxPrice]);

  const handlePriceInput = (value) => {
    const digits = value.replace(/\D/g, '');
    setPriceDraft(digits);
    if (digits.length === 0) return;
    const numeric = Number(digits);
    const clamped = Math.min(Math.max(numeric, 1000), 200000);
    setMaxPrice(clamped);
  };

  return (
    <Popover open={open} onOpenChange={onOpenChange}>
      <PopoverTrigger asChild>
        <Button variant="outline" className="border-gray-700 text-gray-200">
          <Filter className="w-4 h-4 mr-2" />
          Filtros
        </Button>
      </PopoverTrigger>
      <PopoverContent className="bg-gray-950 border-gray-800 text-white w-[320px]">
        <div className="space-y-4">
          <div className="space-y-2">
            <div className="text-xs text-gray-400">Ciudad</div>
            <Select value={selectedCity} onValueChange={setSelectedCity}>
              <SelectTrigger className="bg-gray-900 border-gray-700 text-white">
                <SelectValue placeholder="Ciudad" />
              </SelectTrigger>
              <SelectContent className="max-h-64">
                {cityOptions.map((city) => (
                  <SelectItem key={city} value={city} className="text-white">
                    {city === 'all' ? 'Todas las ciudades' : city}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>

          <div className="space-y-2">
            <div className="text-xs text-gray-400">Comuna</div>
            <Select value={selectedComuna} onValueChange={setSelectedComuna}>
              <SelectTrigger className="bg-gray-900 border-gray-700 text-white">
                <SelectValue placeholder="Comuna" />
              </SelectTrigger>
              <SelectContent className="max-h-64">
                {comunaOptions.map((comuna) => (
                  <SelectItem key={comuna} value={comuna} className="text-white">
                    {comuna === 'all' ? 'Todas las comunas' : comuna}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>

          <div className="space-y-2">
            <div className="flex items-center justify-between text-xs text-gray-400">
              <span>Puntuación mínima</span>
              <span className="text-amber-300">{minRating.toFixed(1)}+</span>
            </div>
            <div className="flex items-center gap-1">
              {[1, 2, 3, 4, 5].map((value) => (
                <button
                  key={value}
                  type="button"
                  onClick={() => setMinRating(value)}
                  className={`p-1 ${value <= minRating ? 'text-amber-400' : 'text-gray-600'}`}
                >
                  <Star className={`w-4 h-4 ${value <= minRating ? 'fill-amber-400' : ''}`} />
                </button>
              ))}
              <Button
                size="sm"
                variant="ghost"
                className="text-xs text-gray-400"
                onClick={() => setMinRating(0)}
              >
                Todas
              </Button>
            </div>
          </div>

          <div className="space-y-2">
            <div className="flex items-center justify-between text-xs text-gray-400">
              <span>Precio máximo</span>
              <span className="text-amber-300">${maxPrice.toLocaleString('es-CL')}</span>
            </div>
            <Slider
              value={[maxPrice]}
              min={5000}
              max={50000}
              step={1000}
              onValueChange={(val) => setMaxPrice(val[0])}
              className="h-2"
            />
            <Input
              value={priceDraft}
              onChange={(e) => handlePriceInput(e.target.value)}
              className="bg-gray-900 border-gray-700 text-white h-9"
              placeholder="Ej: 12000"
              inputMode="numeric"
            />
          </div>
        </div>
      </PopoverContent>
    </Popover>
  );
};

export const BarbershopMapFilters = React.memo(BarbershopMapFiltersComponent);
